import { useMemo } from 'react';
import { getBiLoggerInstance } from '../../bi';
export var useBIInstance = function (_a) {
    var Wix = _a.Wix, biLogger = _a.biLogger;
    var biInstance = useMemo(function () {
        if (Wix && biLogger) {
            return getBiLoggerInstance(biLogger, Wix);
        }
        return null;
    }, [Wix, biLogger]);
    return biInstance;
};
//# sourceMappingURL=useBIInstance.js.map